export default function (Component) {
Component.options.__docs = "<pre><code><span class=\"hljs-section\">&lt;FdTimePicker /&gt;</span></code></pre>"
}